module.exports = __webpack_public_path__ + "img/AS0770027.177c73cd.jpg";